import React, { Fragment } from 'react';
import {
    Icon, Grid, GridCol, Input, Bar, BarItem, ButtonLink, Modal, Dialog, CardHeader, CardFooter, DialogContent, List, ListItem, Addon, Select, Button, Alert
} from 'up-design-system-gex';
import Table from '../Components/Table';
import TableActions from '../Components/TableActions';
import TablePagination from '../Components/TablePagination';
import { convertDateToHumanReadable } from '../helpers';

import { withRouter } from 'react-router-dom';
import Loader from 'up-design-system-gex/build/components/Loader';
import API from '../api';
import { TextField } from '@material-ui/core';

class DashboardRefundsPage extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            // Refunds table
            refunds: null,
            refundsCountInTotal: 0,
            // Refund detail
            refundDetail: null,
            refundReason: "",
            refundStates: [
                "REFUNDED", "NOTREFUNDED", "NEW"
            ],
            refundUpdatedOk: null,
            // Search input
            searchFilter: "",
            searchFilterTimeout: null,
            // Pagination
            paginationCurrentPage: 1,
            paginationRowsPerPage: 10,
            // Sort
            sorting: {
                key: null,
                dir: false,
            },
            refundID: this.props.match.params.id,
        }
        this.handleInputChange = this.handleInputChange.bind(this);
        this.handleDetailButton = this.handleDetailButton.bind(this);

        this.handlePageChange = this.handlePageChange.bind(this);
        this.handleRowsChange = this.handleRowsChange.bind(this);

        this.updateRefundState = this.updateRefundState.bind(this);
    }

    handleInputChange(event) {
        const target = event.target;
        const value = target.value;
        const name = target.name;
        this.setState({
            [name]: value
        });

        if (name === "searchFilter") {
            // Don't call API while user is still typing
            if (this.state.searchFilterTimeout !== null) {
                clearTimeout(this.state.searchFilterTimeout);
                this.setState({ searchFilterTimeout: null });
            }
            const timeout = setTimeout(this.getRefunds.bind(this), 250);
            this.setState({ searchFilterTimeout: timeout });
        }
    }

    handlePageChange(val) {
        this.setState({
            paginationCurrentPage: val,
        }, () => {
            this.getRefunds();
        });
    }

    handleRowsChange(val) {
        this.setState({
            paginationCurrentPage: 1,
            paginationRowsPerPage: val
        }, () => {
            this.getRefunds();
        });
    }

    handleDetailButton(detail) {
        console.log(detail, 'detailClick');
        this.setState({
            refundDetail: detail,
            refundReason: detail.text
        });
    }

    renderTableActionButton(detail) {
        return (
            <ButtonLink
                size="tiny"
                space="condensed"
                className="mb-none"
                data-a11y-dialog-show="dialog-detail-refund"
                onClick={
                    // Zatim takovy hack. Kdyz se totiz toto tlacitko pridava az s daty z API, tak se na nej neprida event listener, ktery by otevrel modal.
                    () => {
                        this.handleDetailButton(detail);
                        document.getElementById("reference-detail-button").click();
                    }
                }
            >
                Detail
            </ButtonLink>
        );
    }

    getRefundStates() {
        API.get("/manualrefunds/states").then(response => {
            if (response.data) {
                this.setState({
                    refundStates: response.data,
                });
            }
        }).catch(error => {
            console.error(error);
        });
    }

    updateRefundState() {
        this.setState({ refundUpdatedOk: null });
        API.put(`/manualrefunds/${this.state.refundDetail.id}`, {
            state: this.state.refundDetail.state,
            text: this.state.refundReason,
        }).then(() => {
            
            //Update refunds in table
            let currentRefunds = this.state.refunds.slice();

            currentRefunds.map(item => {
                if (item.id !== this.state.refundDetail.id)
                    return item;
                item.state = this.state.refundDetail.state;
                item.text = this.state.refundReason;
                return item;
            });

            this.setState({
                refunds: currentRefunds,
                refundUpdatedOk: true,
            });
            this.getRefunds();
        }).catch(error => {
            console.error(error);
        });
    }

    getRefunds() {
        this.setState({ refunds: null });

        let params = {
            page: this.state.paginationCurrentPage - 1,
            recPerPage: this.state.paginationRowsPerPage,
        };
        if (this.state.refundID) {
            params.id = this.props.match.params.id;
        }
        if (this.state.searchFilter.length > 0)
            params.searchText = this.state.searchFilter;
        if (this.state.sorting.key !== null) {
            //hack
            params.order = this.state.sorting.key;
            if(this.state.sorting.key === 'stateText') params.order = 'state';
            params.orderType = this.state.sorting.dir ? "asc" : "desc";
        }
        if(this.state.refundStates.indexOf(this.state.state) !== -1)
        {
            params.state = this.state.state;
        }
        API.get("/manualrefunds", {
            params: params
        }).then(response => {
            if (response.data) {
                let refunds = response.data.transactions;
                let refundsTable = [];
                for (let i = 0; i < refunds.length; i++) {
                    let t = refunds[i];
                    let myDate = new Date(t.created );
                    var day = 5 * 60 * 60 * 24 * 1000;
                    let deadline = new Date(myDate.getTime() + day);
                    var diff = deadline - new Date();
                    let tt = {
                        id: t.id,
                        created: convertDateToHumanReadable(t.created),
                        amount: `${t.amount} ${t.currency}`,
                        pan: t.pan,
                        terminalId: t.terminalId,
                        stanOriginalTran: t.stanOriginalTran,
                        orderNumber: t.orderNumber,
                        createdOriginalTran: convertDateToHumanReadable(t.createdOriginalTran),
                        amountOriginalTran: `${t.amountOriginalTran} ${t.currency}`,
                        state: t.state,
                        stateText: this.translateState(t.state),
                        text: t.text ? t.text : '',
                        diff : this.formatDiff(diff,t.state)
                    };
                    tt.addedAction = this.renderTableActionButton(tt);
                    refundsTable.push(tt);
                    if (this.state.refundID) {
                        this.handleDetailButton(tt);
                        document.getElementById("reference-detail-button").click();
                    }
                }
                this.setState({
                    refunds: refundsTable,
                    refundsCountInTotal: response.data.count,
                });

            }
        }).catch(error => {
            console.error("getRefunds", error);
        });
    }

    translateState(state){
        if(state === 'NEW') return 'Nový'
        if(state === 'REFUNDED') return 'Refundovaný'
        if(state === 'NOTREFUNDED') return 'Nerefundovaný'
    }
    formatDiff(s,status) {
        if(status !== 'NEW') return;
        var ms = s % 1000;
        s = (s - ms) / 1000;
        var secs = s % 60;
        s = (s - secs) / 60;
        var mins = s % 60;
        var hrs = (s - mins) / 60;
        var days = hrs / 24;
        if(days < 1)
        {
            return  <b style={{color:'red'}}>{ hrs + ' h'}</b>; 
        }
        else
        {
            var val = Math.floor(days);
            if(val == 1) return <b style={{color:'red'}}>{val + ' d'}</b>;   
            if(val <= 3) return <b style={{color:'orange'}}>{val + ' d'}</b>;   
            return <b style={{color:'green'}}>{ val + ' d'}</b>; 
        }
        
      }

    renderRefundDetail() {
        const refund = this.state.refundDetail;
        const listItems = [
            { label: "Dátum", value: refund.created },
            { label: "Čiastka", value: refund.amount },
            { label: "PAN", value: refund.pan },
            { label: "Terminál", value: refund.terminalId },
            { label: "STAN", value: refund.stanOriginalTran },
            { label: "Číslo objednávky", value: refund.orderNumber },
            { label: "Dátum platby", value: refund.createdOriginalTran },
            { label: "Suma platby", value: refund.amountOriginalTran },
        ];
        return (
            <List space="condensed">
                {listItems.map(item => (
                    <ListItem key={item.label}>
                        <Grid>
                            <GridCol size={4}>
                                <strong>{item.label}</strong>
                            </GridCol>
                            <GridCol size={8}>
                                {item.value ?? ""}
                            </GridCol>
                        </Grid>
                    </ListItem>
                ))}
                <ListItem>
                    <Grid>
                        <GridCol size={4}>
                            <strong>Stav</strong>
                        </GridCol>
                        <GridCol size={8}>
                            <Select type="one"
                                onChange={(newValue) => {
                                    this.setState({
                                        refundDetail: {
                                            ...refund,
                                            state: newValue.value,
                                        }
                                    });
                                    if (newValue.value !== "NOTREFUNDED") {
                                        this.setState({ refundReason: '' });
                                    }
                                }}
                                value={refund.state}
                            >
                                {this.state.refundStates.map(state => (
                                    <option key={state} value={state}>
                                        {this.translateState(state)}
                                    </option>
                                ))}
                            </Select>
                            {refund.state === "NOTREFUNDED" ?
                                <TextField
                                    fullWidth={true}
                                    rows={3}
                                    multiline={true}
                                    name="refundReason"
                                    label="Dôvod:"
                                    onChange={this.handleInputChange}
                                    placeholder="Dôvod"
                                    type="text"
                                    value={this.state.refundReason}
                                />
                                :
                                <div style={{ height: '150px' }}></div>
                            }
                        </GridCol>
                    </Grid>
                </ListItem>
            </List>
        );
    }

    componentDidMount() {
        this.getRefunds();
        this.getRefundStates();
    }

    render() {
        const modalDetail = (
            <>
                <Modal id="dialog-detail-refund">
                    <Dialog fixed size="xxlarge">
                        <CardHeader>
                            <Bar>
                                <BarItem isFilling>
                                    <h2 className="h4 text-left">Detail refundu</h2>
                                </BarItem>
                                <BarItem>
                                    <ButtonLink
                                        aria-label="Zavrieť dialógové okno"
                                        className="text-color-grey"
                                        data-a11y-dialog-hide
                                        equal
                                        size="tiny"
                                    >
                                        <Icon
                                            spritePath="/sprite.svg"
                                            name="close"
                                            size="medium"
                                        />
                                    </ButtonLink>
                                </BarItem>
                            </Bar>
                        </CardHeader>
                        <DialogContent className="text-left">
                            {
                                !this.state.refundDetail ? (
                                    <Loader
                                        isCentered
                                        size="large"
                                    />
                                ) : (
                                    this.renderRefundDetail()
                                )}
                        </DialogContent>
                        <CardFooter size="condensed" className="align-items-right" style={{ "display": "flex" }}>
                            <Button onClick={this.updateRefundState}>
                                Uložiť
                            </Button>
                        </CardFooter>
                    </Dialog>
                </Modal>
                {this.state.refundUpdatedOk &&
                    <Alert
                        container="#root-alerts"
                        icon="message-success"
                        iconSpritePath="/sprite.svg"
                        type="success"
                        timeout="4000"
                        closeable={true}
                    >
                        Zmeny boli v poriadku uložené
                    </Alert>
                }
            </>
        );

        let refundTableColumns = [
            {
                key: 'created',
                label: 'Dátum',
                thClasses: 'table__col--auto text-nowrap',
                tdClasses: "table__col--auto text-nowrap",
            },
            {
                key: 'amount',
                label: 'Čiastka',
                thClasses: 'table__col--auto text-nowrap',
                tdClasses: "table__col--auto text-nowrap",
            },
            {
                key: 'pan',
                label: 'PAN',
                thClasses: 'table__col--auto text-nowrap',
                tdClasses: "table__col--auto",
            },
            {
                key: 'terminalId',
                label: 'Terminál',
                thClasses: 'table__col--auto text-nowrap',
                tdClasses: "table__col--auto",
            },
            {
                key: 'stanOriginalTran',
                label: 'STAN',
                thClasses: 'table__col--auto text-nowrap',
                tdClasses: "table__col--auto",
            },
            {
                key: 'orderNumber',
                label: 'Číslo obj.',
                thClasses: 'table__col--auto text-nowrap',
                tdClasses: "table__col--auto",
            },
            {
                key: 'createdOriginalTran',
                label: 'Dátum platby',
                thClasses: 'table__col--auto',
                tdClasses: "table__col--auto text-nowrap",
            },
            {
                key: 'amountOriginalTran',
                label: 'Suma platby',
                thClasses: 'table__col--auto text-nowrap',
                tdClasses: "table__col--auto",
            },
            {
                key: 'stateText',
                label: 'Stav',
                thClasses: 'table__col--auto text-nowrap',
                tdClasses: "table__col--auto",
            },
            {
                key: 'diff',
                label: '',
                thClasses: 'table__col--auto text-nowrap',
                tdClasses: "table__col--auto",
                noSort: true
            },
            {
                key: 'addedAction',
                label: 'Akcie',
                thClasses: 'table__col--auto text-nowrap',
                tdClasses: "table__col--auto",
                noSort: true
            }
        ];
        return (
            <div>
                <h2 className="h4">Refundy</h2>
                <TableActions
                    left={[
                        <Grid key="actions-left-1">
                            <GridCol size={{ l: 8, m: 10 }}>
                                <Input
                                    formControlClass="mb"
                                    name="searchFilter" id="searchFilter"
                                    leftAddons={[
                                        <Addon type="filled">
                                            <Icon name="search" size="medium" spritePath="/sprite.svg" />
                                        </Addon>,
                                    ]}
                                    messages={[]}
                                    placeholder="Hľadať" label="Hľadať"
                                    size="small"
                                    type="text"
                                    onChange={this.handleInputChange}
                                />
                                {this.state.refundID &&
                                    <Button onClick={() => { window.location.href = '/'; }}>
                                        Zobraziť všetky refundácie
                                    </Button>
                                }
                            </GridCol>
                            <GridCol size="fill">
                                <Select
                                    size="small"
                                    label="Stav"
                                    id="dropdown-select"
                                    messages={[]}
                                    type="one"
                                    value={this.state.state}
                                    onChange={(newValue) => {
                                        this.setState({
                                                state: newValue.value
                                            },()=>{ this.getRefunds()})
                                        }}
                                >
                                    <option key="ALL">BEZ FILTRA</option>
                                    {this.state.refundStates.map(state => (
                                    <option key={state} value={state}>
                                        {this.translateState(state)}
                                    </option>
                                ))}
                                </Select>
                            </GridCol>
                        </Grid>,
                    ]}
                    right={[]}
                />
                <Table
                    className="table__notice--transparent"
                    sortable
                    sortCallback={
                        (column) => {
                            this.setState({
                                sorting: {
                                    key: column.key,
                                    dir: this.state.sorting.key === column.key ? !this.state.sorting.dir : false
                                }
                            }, () => {
                                this.getRefunds();
                            });
                        }
                    }
                    sorting={this.state.sorting}
                    columns={refundTableColumns}
                    data={this.state.refunds ? this.state.refunds.slice(0, this.state.paginationRowsPerPage) : []}
                    notice={
                        !this.state.refunds &&
                        <Loader
                            id="loader"
                            isCentered
                            size="large"
                        />
                    }
                />
                {modalDetail}
                <ButtonLink
                    size="tiny"
                    space="condensed"
                    className="mb-none"
                    data-a11y-dialog-show="dialog-detail-refund"
                    style={{ display: "none" }}
                    id="reference-detail-button"
                >
                    Detail
                </ButtonLink>
                {(this.state.refunds && this.state.refunds.length > 0) &&
                    <Fragment>
                        <TablePagination
                            currentPage={this.state.paginationCurrentPage}
                            totalPages={Math.ceil(this.state.refundsCountInTotal / this.state.paginationRowsPerPage)}
                            rowsPerPage={this.state.paginationRowsPerPage}
                            currentCount={this.state.refunds?.length || 0}
                            handlePageChange={this.handlePageChange}
                            handleRowsChange={this.handleRowsChange}
                        />
                    </Fragment>
                }
            </div>
        );
    }
}

export default withRouter(DashboardRefundsPage);